import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import VueSmoothScroll from 'vue2-smooth-scroll';
import VueCookie from 'vue-cookie';
import flatpickr from 'flatpickr';

import components from './components';
import contentLock from './helpers/content-lock';
import plugins from './plugins';
import store from './store';

plugins.init();
Vue.use(VueSmoothScroll);
Vue.use(VueCookie);

new Vue({ // eslint-disable-line no-new
    el: '#app',
    components,
    store,
    data() {
        return {
            blankImage: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
            showMenu: false,
            contactType: 'E-mail',
            placeName: '',
            showNotification: true,
        };
    },
    computed: {
        ...mapState('modal', [
            'modal',
        ]),

        getPlace() {
            return VueCookie.get('place');
        },
    },
    mounted() {
        const placeField = document.querySelectorAll('#place');

        if (placeField.length) placeField[0].value = this.getPlace;

        flatpickr('.js-datepicker', {
            disableMobile: 'true',
            dateFormat: 'd-m-Y',
        });
    },
    methods: {
        ...mapMutations('modal', [
            'setModal',
        ]),

        toggleMenu() {
            this.showMenu = !this.showMenu;
            contentLock.toggle();
        },

        setPlace(place) {
            if (place.length) VueCookie.set('place', place, 1);
            else if (this.placeName.length) VueCookie.set('place', this.placeName, 1);
        },

        closeNotification() {
            this.showNotification = false;
        },
    },
});
